
































import { Component, Vue } from "vue-property-decorator";
import { Getter } from "vuex-class";

@Component({})
export default class extends Vue {
  @Getter("auth/isAuthorized")
  public isAuthorized!: boolean;
}
